import YourAdvice from '../components/YourAdvice';
import MedicalQuestionnaireProgressBanner from '../components/MedicalQuestionnaireProgressBanner';
import { PORTAL_PAGE_CONTAINER_CLASS } from '../utils/constants';

export default function YourAdvicePage() {
  return (
    <div className="min-w-screen min-h-screen bg-[#F9F5F2] py-8 md:py-12">
      <div className={PORTAL_PAGE_CONTAINER_CLASS}>
        <MedicalQuestionnaireProgressBanner />
        <YourAdvice />
      </div>
    </div>
  );
}
